import React, {useState, forwardRef, useImperativeHandle, useRef, useEffect} from "react";
import {Modal, message, Input, notification} from 'antd'
import {AuthButton,WWTable,SimpleTreeUpdate,WWInput} from "@/globalComponents";
import {WWMethods,wwConstants,WWUtils} from "@/tools";
const TextArea = Input.TextArea;
const deviceInfoParams = wwConstants.deviceInfoParams;
function DeviceDetail(props, ref) {
    const [visible, setVisible] = useState(false);
    const [organizationId,setOrganizationId] = useState("");
    const [organizationName,setOrganizationName] = useState("");
    const [imei,setImei] = useState("");
    const [imeiDetail,setImeiDetail] = useState({});
    const [deviceLiftList,setDeviceLiftList] = useState([]);
    const deviceDetail_tree_Ref = useRef(null);

    useImperativeHandle(ref, () => ({
        setModalVisible: (visible,imei) => {
            setVisible(visible);
            setImei(imei);
            getDeviceDetail(imei);
           getDeviceLifeList(imei);
        }
    }));

    useEffect(()=>{
        visible && deviceDetail_tree_Ref.current && deviceDetail_tree_Ref.current.updateDatas_simple({
            treeVisible: false,
            popVisible: false,
            showSelect: true,
            expandKeys: [imeiDetail.orgId.toString()],
            organizationName: imeiDetail.orgName,
            selectedKeys: [imeiDetail.orgId.toString()],
            organizationId: "",
            showRootName: false,
            isTallTree: true
        });
    },[imeiDetail])
    //重置功能
    const resetParams = ()=>{
        setVisible(false);
        setOrganizationId("");
        setImei("")
        setImeiDetail({})
        setDeviceLiftList([])
    }
    //获取设备生命周期列表
    const getDeviceLifeList = (imei)=>{
        if(imei){
            let params ={
                "pageable": false,
                "group": "device",
                "target": imei
            }
            WWMethods.getDeviceLiftCycle(params,(data)=>{
                setDeviceLiftList(data);
            });
        }
    }
    //获取设备详情
    const getDeviceDetail = (imei)=>{
        if(imei){
            WWMethods.getDeviceDetail(imei,(data)=>{
                setImeiDetail(data);
                setOrganizationId(data.orgId);
                setOrganizationName(data.orgName)
            });
        }

    }
    //组装参数
    const formatParms = ()=>{
        return{
            orgId:organizationId,
            carCode: imeiDetail.carCode,
            sim:imeiDetail.sim,
            remark:imeiDetail.remark,
            imei:imeiDetail.imei
        }
    }
    //确定修改
    const handleImport = () => {
        WWMethods.modifyDevice(formatParms(),(data) => {
            message.success(Strings.optsuccess || "操作成功");
            //初始化参数
            resetParams();
        });
    }
    //关闭弹框
    const  hideModal = ()=> {
        //初始化参数
        resetParams();
    }
    //更新设备详情
    const updateDetail = (e,paramName)=>{
        let user =  WWMethods.trimStr(e)
        let temp_detail =JSON.parse(JSON.stringify(imeiDetail)) ;
        temp_detail[paramName] = user;
        setImeiDetail(temp_detail);
    }

    const createNotice =()=>{
        const popTips = <span>{Strings.downloadLocalTips || "导出任务已执行，请稍后自行前往导出任务进行下载保存。"}</span>
        let exportTitle = Strings.downloading || "导出中"
        notification.destroy();
        notification.open({
            message:exportTitle,
            description:popTips,
            getContainer:()=>document.getElementById("deviceDetail"),
            icon:<i className="icon green iconfont icon-daochuzhong"></i>,
            duration: 10,
            top:150
        })
    }
    /**
     * 下载同批设备
     */
    const downloadImeis = (serialNo)=>{
        let params = {};
        params.type = "deviceOutSameBatch";//导出类型
        params.fileType = 1;//1:excel,2:pdf
        params.param = {};
        params.param.serialNo = serialNo;//销售流水号
        //邮箱导出获取邮箱数据
        WWMethods.downloadVinList(params,(data)=>{
            if(data.code === 0){
                createNotice();
            }else {
                message.error(data.message)
            }
        })
    }
    const handleAccountChange = (orgId, accountName, isGetSubAccounts)=>{
        setOrganizationId(orgId);
    }
    const columns_device_life =[
        {
            title: Strings.time || "时间" ,
            dataIndex: 'updateTime',
            width:'20%',
            render:(text)=>{
                return WWUtils.formatTimeYMDHms(text);
            }
        },
        {
            title: Strings.updateUser || "操作人员" ,
            dataIndex: 'updateUser',
            width:'20%'
        },
        {
            title: Strings.event || "事件" ,
            dataIndex: 'typeName',
            width:'15%'
        },
        {
            title: Strings.detail || "详细信息" ,
            dataIndex: '',
            width:'45%',
            render:(text,record)=>{
                let content = record.formatContent;
                if(record.type.toString() === "1005"){
                    content = <a className={"blueF"} onClick={()=>{downloadImeis(record.formatContent)}}>{Strings.viewAllImei || "查看同批入库设备"}</a>;
                }
                return content;
            }
        },
    ]
    return (
        <Modal {...props} ref={ref} transitionName="" maskTransitionName="" visible={visible}
               destroyOnClose={true}
               className={"default_modal"}
               width={1058}
               maskClosable={false} title={(Strings.imei || "设备")+" "+imei+" "+ (Strings.detail1 || "详情")}
               onCancel={() => {
                   hideModal();
               }} footer={null}>
                <div className={"modal_item brb1  pdt15 pdb7"}>
                    <div className={"detail_item"}>
                        <label className={"font w100p"}>{Strings.orgName1 || "所属用户："}</label>
                        <div className={`deviceDetail_tree_wrapper`} style={{display:"inline-block",position:"relative",marginLeft:7}}>
                            <SimpleTreeUpdate ref={deviceDetail_tree_Ref}
                                              selectWidth={200}
                                              margins={"5px auto"}
                                              organizationId={organizationId}
                                              parentClass={`deviceDetail_tree_wrapper`}
                                              directShowTree={false}
                                              showRootName={false}
                                              handleChange={handleAccountChange}
                                              sendAccountId={handleAccountChange}
                            />
                        </div>
                    </div>
                    <div className={"detail_item"}>
                        <label className={"font w100p"}>{Strings.carCode1 || "机械编号："}</label>
                        <WWInput className={"w200 mgl10"} value={imeiDetail.carCode} disabled={true}/>
                    </div>
                    <div className={"detail_item"}></div>
                </div>
            <div className={"titleblue mgb10"}>{Strings.terminal || "终端信息："}{imeiDetail.imei} <span className={imeiDetail["expired"]?"red":""}>{imeiDetail["expireNotice"]}</span></div>
                <div className={"modal_item brb1 pdb7"}>
                    {deviceInfoParams.map((item)=>{
                        if(item.key === "remark"){
                            return  <div className={"detail_item w31"}>
                                <label className={"font w100p"}>{item.title}</label>
                                <WWInput type="textarea" className={"mgl10"}
                                       value={imeiDetail[item.key]}
                                       onChange={(e) => {
                                           updateDetail(e,item.key)
                                       }}
                                       maxLength={128}
                                       style={{
                                               width: 536,
                                               maxHeight: 50,
                                               minHeight: 50,
                                               minWidth: 536,
                                             maxWidth: 536
                                       }}/>
                            </div>
                        }else{
                            let value = imeiDetail[item.key];
                            if(item.key === "firstPosition"){
                                if(imeiDetail["firstPositionLat"] && imeiDetail["firstPositionLng"]){
                                    value= imeiDetail["firstPositionLng"] +","+imeiDetail["firstPositionLat"]
                                }else{
                                    value = ""
                                }
                            }else if((item.key === "position") ){
                                if(imeiDetail["lng"] && imeiDetail["lat"]){
                                    value= imeiDetail["lng"] +","+imeiDetail["lat"]
                                }else{
                                    value = ""
                                }
                            }
                            if(item.type === "time"){
                                value = WWUtils.formatTimeYMDHms(imeiDetail[item.key]);
                            }
                            if(item.type === "day"){
                                value = WWUtils.formatTimeYMD(imeiDetail[item.key]);
                            }
                            return  <div className={"detail_item w31"}>
                                <label className={"font w100p"}>{item.title}</label>
                                <WWInput className={"w200 mgl10"} disabled={item.disabled} value={value} onChange={(e)=>{
                                    if(!item.disabled){
                                        updateDetail(e,item.key)
                                    }
                                }}/>
                            </div>
                        }

                    })}
                </div>
                <div className={"titleblue mgb10"}>{Strings.deviceLife || "设备生命周期"}</div>
                <WWTable  className="new_app_table"
                          id={"deviceDetail"}
                          pagination={false}
                          columns={columns_device_life}
                          innerHeight={280}
                          hiddenPagination={true}
                          dataSource={deviceLiftList}/>
                <div className="modal_item modal_btns mgt24">
                    <AuthButton authKey={true}  onClick={()=>{  hideModal()}}>{Strings.close || "关闭" }</AuthButton>
                    <AuthButton authKey={true} className="mg_left10" type="primary" onClick={()=>handleImport()}>{Strings.save || "保存"}</AuthButton>
                </div>
        </Modal>
    )
}
export default forwardRef(DeviceDetail)
